
import { Component, Inject, OnInit, DOCUMENT } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NetworkService } from '../network.service';
@Component({
    selector: 'app-layouts',
    templateUrl: './layouts.component.html',
    styleUrl: './layout.component.scss',
    standalone: false
})
export class LayoutsComponent implements OnInit {

  constructor(@Inject(DOCUMENT) private document: Document, private networkStatusService: NetworkService, private toastr: ToastrService) { }


  onActivate(event: any) {
    this.document.body.scrollTop = 0;
  }

  connectionStatusMessage: string = '';
  connectionStatus: string = '';
  isNetworkOnline: boolean = true;

  ngOnInit() {
    this.connectionStatusMessage = this.networkStatusService.connectionStatusMessage;
    this.connectionStatus = this.networkStatusService.connectionStatus;

    this.networkStatusService.onlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Back to online';
      this.connectionStatus = 'online';
      this.isNetworkOnline = true;
      this.toastr.success(this.connectionStatusMessage)
    });

    this.networkStatusService.offlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Connection lost! You are not connected to internet';
      this.connectionStatus = 'offline';
      this.isNetworkOnline = false;
      this.toastr.error(this.connectionStatusMessage)
    });
  }

  ngOnDestroy() {
    this.networkStatusService.ngOnDestroy();
  }

  reloadPage() {
    window.location.reload();
  }
}
